export default __webpack_public_path__ + "static/media/PrivacyPolicy.a53c94d8.txt";